import React from 'react';

interface HeadlessRefitContextType {
  // Called by ag-grid matrix gadgets (Matrix / RankingMatrix / PaceMatrix /
  // SingleMetricDateMatrix) under the scheduled-report PDF print route to report
  // their natural rendered content height in pixels, keyed by card id
  // (CardContext.i === react-grid-layout item i). The canvas uses these heights
  // to refit each grid card's slot to its content so the PDF has no whitespace
  // band below the last row. Pass `undefined` to deregister on unmount.
  reportContentHeight: (
    cardId: string,
    gridContentPx: number | undefined,
  ) => void;
}

const HeadlessRefitContext = React.createContext<HeadlessRefitContextType>({
  reportContentHeight: () => {},
});

export default HeadlessRefitContext;
